import React from "react";
import "./Work.css";
import { motion } from "framer-motion";

const Work = () => {
  // Variants
  const containerVariants = { hidden: {}, visible: { transition: { staggerChildren: 0.3 } } };
  const cardVariants = { hidden: { opacity: 0, y: 50 }, visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } } };
  const paragraphVariants = { hidden: { opacity: 0, x: -50 }, visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } } };
  const listVariants = { hidden: { opacity: 0, x: -30 }, visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } } };

  return (
    <section id="work" className="work section-padding">

      {/* Header */}
      <motion.div
        className="work-header"
        initial={{ opacity: 0, y: -50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 1 }}
      >
        <h2>My Work Experience</h2>
        <p>
          Senior Software Engineer with 4+ years of experience in designing, 
          developing, and deploying modern web applications. Proficient in 
          React.js, Node.js, Express.js, MongoDB, MySQL, HTML, CSS, and 
          JavaScript, with a proven ability to deliver scalable, responsive, 
          and user-friendly solutions. Passionate about writing clean, 
          maintainable code, optimizing performance, and collaborating with 
          cross-functional teams to build impactful digital products.
        </p>
      </motion.div>

      {/* Work Cards */}
      <motion.div
        className="work-cards"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        variants={containerVariants}
      >

        {/* Senior Software Engineer */}
        <motion.div className="work-card" variants={cardVariants}>
          <motion.h3 variants={paragraphVariants}>Senior Software Engineer</motion.h3>
          <motion.h4 variants={paragraphVariants}>Careers Creep Pvt. Ltd | Apr 2024 – Present</motion.h4>
          <motion.p variants={paragraphVariants}>
            Lead the development of scalable web applications with a strong focus 
            on performance, UX, and clean architecture. Collaborate with 
            cross-functional teams to deliver high-quality solutions while 
            mentoring junior developers.
          </motion.p>
          <motion.ul variants={listVariants}>
            <motion.li variants={listVariants}>Built and maintained responsive websites using React.js, Tailwind CSS, and Node.js.</motion.li>
            <motion.li variants={listVariants}>Designed reusable UI components and integrated REST APIs for seamless functionality.</motion.li>
            <motion.li variants={listVariants}>Optimized applications for performance, scalability, and cross-platform compatibility.</motion.li>
            <motion.li variants={listVariants}>Delivered multiple websites from scratch, reducing load times and improving UX.</motion.li>
            <motion.li variants={listVariants}>Enhanced backend services with Node.js for dynamic and secure applications.</motion.li>
          </motion.ul>
        </motion.div>

        {/* Software Engineer */}
        <motion.div className="work-card" variants={cardVariants}>
          <motion.h3 variants={paragraphVariants}>Software Engineer</motion.h3>
          <motion.h4 variants={paragraphVariants}>XANTT Technologies Pvt. Ltd | Jun 2021 – March 2024</motion.h4>
          <motion.p variants={paragraphVariants}>
            Developed and deployed multiple web applications using modern 
            front-end and back-end technologies, focusing on responsive design, 
            functionality, and client requirements.
          </motion.p>
          <motion.ul variants={listVariants}>
            <motion.li variants={listVariants}>Built and maintained websites using HTML, CSS, JavaScript, and React.js.</motion.li>
            <motion.li variants={listVariants}>Developed backend features with Node.js, working on APIs and integrations.</motion.li>
            <motion.li variants={listVariants}>Worked with MongoDB and MySQL for database design, queries, and data handling.</motion.li>
            <motion.li variants={listVariants}>Collaborated with designers and backend teams to deliver full-stack solutions.</motion.li>
            <motion.li variants={listVariants}>Enhanced website performance and usability through clean, optimized code.</motion.li>
          </motion.ul>
        </motion.div>

      </motion.div>

    </section>
  );
};

export default Work;
